<template>
  <div id="player_on_off" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined">
        <team-select v-model="team_selected" :options="team_dropdown" :inputFunc="changePlayers" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>

      <div class="col-md-2" v-if="players.length > 0 && ($route.params.type === 'team' || $route.params.type === 'player')">
        <player-select v-model="player_selected" :options="players" label="Player"></player-select>
      </div>

      <div class="col-md-2" v-if="leverage_dropdown.data != undefined && ($route.params.league == 'nba' || $route.params.league == 'wnba')">
        <label class="typo__label">{{ leverage_dropdown.label }}</label>
        <multiselect
          v-model="leverage_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :options="leverage_dropdown.data"
          :searchable="false"
          :show-labels="false"
          placeholder=""
          :preselect-first="false"
          :allow-empty="true"
          :close-on-select="false"
          :multiple="true">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
      </div>

      <div class="col-md-2" v-if="stat_options.data != undefined">
        <label class="typo__label">{{ stat_options.label }}</label>
        <multiselect
          v-model="stat_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="stat_options.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Get Stats</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div id="on-off-table-container">
      <div id="on-off-table-container2" v-if="table_data.length > 0 && ($route.params.type === 'team' || $route.params.type === 'stat')">
        <vue-good-table
          :columns="table_columns"
          :rows="table_data"
          :pagination-options="{ enabled: false}"
          :searchOptions="{ enabled: false}"
          :sort-options="{ enabled: true}"
          styleClass="vgt-table bordered striped">
        </vue-good-table>
      </div>

      <div id="on-off-table-container2" v-if="stat_selected != undefined && $route.params.type === 'player'">
        <vue-good-table
          :columns="table_columns"
          :rows="table_data[stat_selected.id]"
          :pagination-options="{ enabled: false}"
          :searchOptions="{ enabled: false}"
          :sort-options="{ enabled: true}"
          styleClass="vgt-table bordered striped">
        </vue-good-table>
      </div>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import { tableUtils } from './mixins/table_utils'
import { teamPlayerOnOff, season, seasonType, leverage } from './mixins/dropdowns'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import PlayerSelect from './mixins/PlayerSelect.vue'

export default {
  name: 'PlayerOnOff',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PlayerSelect
  },
  mixins: [tableUtils, SeasonTypeSelect, SeasonSelect, TeamSelect, PlayerSelect, GetDropdownOptions, teamPlayerOnOff, seasonType, season, leverage],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_selected_string: '',
      players: [],
      player_selected: undefined,
      team_dropdown: {},
      team_selected: undefined,
      table_data: [],
      table_columns: {},
      leverage_dropdown: {},
      leverage_selected: [],
      stat_selected: undefined,
      stat_options: {},
      use_min_filters: false,
      use_text_filters: false,
      show_error_message: false,
      api_endpoint: 'get-on-off/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.table_data = []
      this.seasons_selected = []
      this.leverage_selected = []
      this.$router.push({name: 'on_off', params: {league: this.$parent.league, type: this.$route.params.type}})
    },
    setStatOptionDropdown () {
      if (this.$route.params.type === 'stat') {
        this.stat_options = this.team_player_on_off_dropdown
        this.stat_options.data.forEach((stat) => {
          if (stat.id === this.$route.query.Stat) {
            this.stat_selected = stat
          }
        })
        // on league change this will be undefined so set to first option
        if (!this.stat_selected) {
          this.stat_selected = this.stat_options.data[0]
        }
      } else {
        this.stat_options = {}
        this.stat_selected = undefined
      }
    },
    checkIfStatsShouldBeLoaded () {
      this.leverage_dropdown = this.leverage_dropdown_options
      this.setLeverageSelected()
      if (this.seasons_selected.length > 0 && this.season_type_selected && this.team_selected) {
        this.changePlayers()
        this.getStats()
      }
    },
    loadData () {
      this.table_data = []
      this.stat_selected = undefined
      this.getDropdown([this.setTeamDropdown, this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setStatOptionDropdown, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.TeamId) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changePlayers () {
      if (this.$route.params.type === 'player' || this.$route.params.type === 'team') {
        this.getPlayersForTeam([this.setPlayerSelected])
      }
    },
    getLeverageString () {
      var leverageString = ''
      for (var i = 0; i < this.leverage_selected.length; i++) {
        if (i === 0) {
          leverageString += this.leverage_selected[i].id
        } else {
          leverageString += ',' + this.leverage_selected[i].id
        }
      }
      return leverageString
    },
    setLeverageSelected () {
      this.leverage_selected = []
      if (this.$route.query.Leverage) {
        this.leverage_dropdown.data.forEach((leverageOption) => {
          this.$route.query.Leverage.split(',').forEach((leverageSelected) => {
            if (leverageOption.id === leverageSelected) {
              this.leverage_selected.push(leverageOption)
            }
          })
        })
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      if (this.team_selected) {
        params[this.$teamIdParam] = this.team_selected.id
      }
      if (this.$route.params.type === 'player' || this.$route.params.type === 'team') {
        params[this.$playerIdParam] = this.player_selected.playerId
      } else if (this.$route.params.type === 'stat') {
        params[this.$statParam] = this.stat_selected.id
      }

      if (this.leverage_selected.length > 0) {
        params[this.$leverageParam] = this.getLeverageString()
      }

      this.$router.push({name: 'on_off', query: params})
    },
    getStats () {
      this.show_error_message = false

      var params = this.$route.query

      if (params.Season && params.SeasonType && params.TeamId) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league + '/' + this.$route.params.type, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.table_data = response.data.results
              this.table_columns = response.data.headers

              if (this.$route.params.type === 'player') {
                this.stat_options = response.data.stat_options
              }

              if (this.$route.params.type === 'stat') {
                this.table_columns.forEach((column) => {
                  if (column.field === 'On') {
                    column.label = this.stat_selected.text + ' with Player On'
                  } else if (column.field === 'Off') {
                    column.label = this.stat_selected.text + ' with Player Off'
                  }
                })
              }
            } else {
              this.show_error_message = true
              this.table_data = []
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
            this.table_data = []
          })
      }
    }
  }
}
</script>

<style scoped>
#on-off-table-container2{
  min-width:50%;
  display:inline-block;
}
#on-off-table-container{
  min-width:350px;
  width:100%;
}
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"
</style>



// WEBPACK FOOTER //
// src/components/PlayerOnOff.vue